export default __webpack_public_path__ + "static/media/mp4.46542051.png";